import { useLazyQuery } from '@apollo/client/react';
import { GET_PRESIGNED_DOWNLOAD_URL } from '../queries/GetPreSignedDownloadUrl';
import { LoggerContextProps } from '../types/LogContext';
import { handleError } from './errorHandler';

interface PresignedDownloadState {
  isLoading: boolean;
  error: string | null;
}
export enum ResourceType {
  DOCUMENT = 'DOCUMENT',
  REPORT = 'REPORT',
}

export function usePresignedDownload() {
  const context: LoggerContextProps = {
    action: 'usePresignedDownload',
    caseId: '',
  };

  const [getPresignedDownloadUrlQuery, { data, loading, error }] = useLazyQuery<{
    getPreSignedDownloadUrl: { url: string };
  }>(GET_PRESIGNED_DOWNLOAD_URL, {
    fetchPolicy: 'network-only',
  });
  const getPresignedDownloadUrl = async (resource_id: string, id: string, type: ResourceType) => {
    context.caseId = id;
    try {
      const { data } = await getPresignedDownloadUrlQuery({
        variables: {
          input: {
            resource_id,
            case_id: id,
            type,
          },
        },
      });
    } catch (error) {
      handleError(error, context, 'Failed to get presigned download URL.');
    }
  };

  return { getPresignedDownloadUrl, data, loading, error };
}
